import { PropsWithChildren, ReactNode, Ref } from 'react';

import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalCloseButtonProps,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalFooterProps,
  ModalHeader,
  ModalHeaderProps,
  ModalOverlay,
  ModalOverlayProps,
  ModalProps as ChakraModalProps,
} from '@chakra-ui/react';

export type ModalProps = PropsWithChildren<
  ChakraModalProps & {
    title: ReactNode | string;
    footerButtons?: ReactNode;
    modalOverlayProps?: ModalOverlayProps;
    showCloseButton?: boolean;
    modalHeaderProps?: ModalHeaderProps;
    modalContentProps?: ModalContentProps;
    modalFooterProps?: ModalFooterProps;
    modalCloseButtonProps?: ModalCloseButtonProps;
    /** `ModalBody` is the scroll container under `scrollBehavior='inside'`. */
    modalBodyRef?: Ref<HTMLDivElement>;
  }
>;

export function Modal({
  title,
  footerButtons,
  modalOverlayProps,
  children,
  showCloseButton = true,
  modalHeaderProps,
  modalContentProps,
  modalFooterProps,
  modalCloseButtonProps,
  modalBodyRef,
  ...rest
}: ModalProps) {
  return (
    <ChakraModal {...rest}>
      <ModalOverlay {...modalOverlayProps} />
      <ModalContent {...modalContentProps}>
        <ModalHeader {...modalHeaderProps}>{title}</ModalHeader>
        {showCloseButton && <ModalCloseButton {...modalCloseButtonProps} />}
        <ModalBody ref={modalBodyRef}>{children}</ModalBody>
        {footerButtons && (
          <ModalFooter gap={6} {...modalFooterProps}>
            {footerButtons}
          </ModalFooter>
        )}
      </ModalContent>
    </ChakraModal>
  );
}
